

export const paymentLinkDates = [
    {
      value: 1,
      label: "1 Saat",
    },
    {
      value: 2,
      label: "6 Saat",
    },
    {
      value: 3,
      label: "12 Saat",
    },
    {
      value: 4,
      label: "1 Gün",
    },
    {
      value: 5,
      label: "2 Gün",
    },
    {
      value: 6,
      label: "1 Hafta",
    },
  ];


  export const getExpireDateDesc =(id)=>{
  
    var index = paymentLinkDates.findIndex(w=>w.value == id);
    return paymentLinkDates[index].label;
  }

  export const getExpireDateById =(id)=>{
  
    var index = paymentLinkDates.findIndex(w=>w.value == id);
    return paymentLinkDates[index];
  }